/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Level_0_HintInputs */

const en_sch_level_0_hint = /** @type {(inputs: Sch_Level_0_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The smallest piece of work. Can sit under any type of a higher level.`)
};

const de_sch_level_0_hint = /** @type {(inputs: Sch_Level_0_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das kleinste Arbeitspaket. Kann unter jedem Typ einer höheren Ebene stehen.`)
};

/**
* | output |
* | --- |
* | "The smallest piece of work. Can sit under any type of a higher level." |
*
* @param {Sch_Level_0_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_level_0_hint = /** @type {((inputs?: Sch_Level_0_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Level_0_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_level_0_hint(inputs)
	return en_sch_level_0_hint(inputs)
});